module.exports = __webpack_public_path__ + "static/img/ing.7e6d1b90.png";